export default {
  title: 'Informação Empresarial',
  form: {},
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    success: 'Informação guardada com sucesso.',
  },
};
